import "./index.less";

export class Education {
  constructor(clas) {
    // 获取根元素
    this.el = document.querySelector(clas);
    // 缓存常用DOM节点
    this.DOM = {
      navList: this.el.querySelector(".nav-list"),
      navItems: this.el.querySelectorAll(".nav-item"),
      leftBtn: this.el.querySelector(".nav-arrow--left"),
      rightBtn: this.el.querySelector(".nav-arrow--right"),
      tabPanes: this.el.querySelectorAll(".education--list"),
      tabSwipers: this.el.querySelectorAll(".education-swiper"),
      swiper: this.el.querySelector(".active-swiper"),
    };

    // 获取单个item宽度（包含margin-right）
    this.itemWidth = this.getItemWidth();
    this.scrollStep = this.itemWidth || 333;
    this.swiperInstance = null; // swiper实例
    this.init();
  }
  /**
   * 初始化方法
   */
  init() {
      this.DOM.swiper && this.reInitSwiper();
      this.navScroll();
      this.updateArrows();
      // 监听滚动事件，动态更新箭头显示
      this.DOM.navList.addEventListener("scroll", () => this.updateArrows());
      window.addEventListener("resize", () => {
        this.itemWidth = this.getItemWidth();
        this.scrollStep = this.itemWidth || 333;
        this.updateArrows();
      });

    // 绑定导航项点击事件
    this.DOM.navItems.forEach((item, index) => {
      item.addEventListener("click", () => this.handleNavItemClick(index));
    });
  }
  /**
   * 获取单个导航项的宽度（包含margin-right）
   */
  getItemWidth() {
    if (!this.DOM.navItems[0]) return 0;
    const style = window.getComputedStyle(this.DOM.navItems[0]);
    const width = this.DOM.navItems[0].offsetWidth;
    const marginRight = parseInt(style.marginRight, 10) || 0;
    return width + marginRight;
  }

  /**
   * 处理导航项点击事件
   * @param {number} index - 导航项的索引
   */
  handleNavItemClick(index) {
    // 移除所有导航项的active类
    this.DOM.navItems.forEach((item) => item.classList.remove("active-item"));
    // 给当前点击的导航项和对应的tab-pane添加active类
    this.DOM.navItems[index].classList.add("active-item");
    // 重新初始化swiper
      this.DOM.tabSwipers.forEach((swiper) =>
        swiper.classList.remove("active-swiper")
      );
      this.DOM.tabSwipers[index].classList.add("active-swiper");
      // 重新获取当前swiper
      this.DOM.swiper = this.el.querySelector(".active-swiper");
      this.reInitSwiper();
  }

  /**
   * 导航栏滚动及按钮事件绑定
   */
  navScroll() {
    // 左右按钮存在时绑定事件
    if (this.DOM.leftBtn && this.DOM.rightBtn) {
      this.DOM.leftBtn.addEventListener("click", () => {
        this.DOM.navList.scrollBy({
          left: -this.scrollStep,
          behavior: "smooth",
        });
        setTimeout(() => this.updateArrows(), 300);
      });
      this.DOM.rightBtn.addEventListener("click", () => {
        this.DOM.navList.scrollBy({
          left: this.scrollStep,
          behavior: "smooth",
        });
        setTimeout(() => this.updateArrows(), 300);
      });
    }
  }

  /**
   * 根据当前滚动位置，动态显示/隐藏左右箭头
   */
  updateArrows() {
    if (!this.DOM.navList) return;
    // 到头隐藏左箭头
    if (this.DOM.navList.scrollLeft <= 0) {
      if (this.DOM.leftBtn) this.DOM.leftBtn.style.visibility = "hidden";
    } else {
      if (this.DOM.leftBtn) this.DOM.leftBtn.style.visibility = "visible";
    }
    // 到尾隐藏右箭头
    if (
      this.DOM.navList.scrollLeft + this.DOM.navList.offsetWidth >=
      this.DOM.navList.scrollWidth - 1
    ) {
      if (this.DOM.rightBtn) this.DOM.rightBtn.style.visibility = "hidden";
    } else {
      if (this.DOM.rightBtn) this.DOM.rightBtn.style.visibility = "visible";
    }
  }

  /**
   * 初始化swiper
   */
  reInitSwiper() {
    if (this.swiperInstance && typeof this.swiperInstance.destroy === "function") {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
    if (this.DOM.swiper) {
      this.swiperInstance = new Swiper(this.DOM.swiper, {
        slideToClickedSlide: true,
        autoplay: false,
        freeMode: false,
        speed: 600,
        loop: false,
        pagination: {
          el: ".active-swiper-pagination",
        },
        navigation: {
          prevEl: `.swiper-activity-button-prev`,
          nextEl: `.swiper-activity-button-next`
      },
      });
    }
  }
}


